import logo from './logo.svg';
import './App.css';
import Card from './components/Card';
import Photo from './components/Photo';
import Info from './components/Info';
import About from './components/About';
import Interests from './components/Footer';

function App() {
  return (
   <div className="App">
     <Card/>
   </div>
  );
}

export default App;
